import { useGameOpt } from "~/app";
import { Colors } from "../theme";

export const usePlayerColor = (playerId?: string): string | null => {
  const { game } = useGameOpt() ?? {};
  let playerIndex: number | null = null;
  if (game && playerId) {
    const player = game.getPlayer(playerId);
    playerIndex = game.players.indexOf(player);
  }
  return playerIndex === null ? null : Colors.players[playerIndex].main;
};
